module.exports = __webpack_public_path__ + "c2534654e64f4c6f307ee9be68e554bc.svg";